import { Typography } from '@mui/material';
import { useOrganisationData } from '../../../Hooks/useOrganisation';
import { useUserInfoData } from '../../../Hooks/useUserInfo';
import OverflowItem from '../Overflow/OverflowItem';
import StyledBox from './styles';

export default function AccountInformation() {
  const userInfo = useUserInfoData();
  const org = useOrganisationData();

  return (
    <StyledBox>
      <OverflowItem position="right" id="account-info" priority={10}>
        <Typography variant="subtitle1">
          {userInfo.displayName}
        </Typography>
        <Typography variant="subtitle1">
          {org.displayText}
        </Typography>
      </OverflowItem>
    </StyledBox>
  );
}
